import React, { useState, useEffect } from 'react';
import { BiArrowToTop } from 'react-icons/bi';
import '../App.css';

function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Detectar rolagem da página
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Voltar ao topo suavemente
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="back-to-top d-flex align-items-center justify-content-center"
          aria-label="Voltar ao Topo"
        >
          <BiArrowToTop size={24} />
        </button>
      )}
    </>
  );
}

export default BackToTop;
